// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"StyledButtonWrap_Wrap__1USeC","LeftIcon":"StyledButtonWrap_LeftIcon__LbZ7Q","RightIcon":"StyledButtonWrap_RightIcon__AafwD","Caption":"StyledButtonWrap_Caption__3IWcC"};